<template>
  <div class="home">
    <Support :appLogo="appLogo" :appTitle="appTitle" />
  </div>
</template>

<script>
// @ is an alias to /src
import Support from '@/components/Support.vue'

export default {
  props:['appLogo', 'appTitle'],
  name: 'SupportView',
  components: {
    Support
  }
}
</script>
